module.exports = __webpack_public_path__ + "img/236.38a4c706.jpg";